/**
 * JSON-LD Schema generators — Up Diag
 * Inject via <script type="application/ld+json" dangerouslySetInnerHTML={{__html: ...}}>
 */

import { SHOW_REVIEWS } from "@/config/features";

const SITE = "https://updiag.fr";

export const schemaLocalBusiness = () => {
  const base: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Up Diag",
    url: SITE,
    telephone: "+33100000000",
    priceRange: "€€",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Paris",
      addressRegion: "Île-de-France",
      addressCountry: "FR",
    },
    areaServed: ["Paris", "Île-de-France"],
  };
  if (SHOW_REVIEWS) {
    base.aggregateRating = {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "127",
    };
  }
  return JSON.stringify(base);
};

export const schemaWebSite = () => JSON.stringify({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Up Diag",
  url: SITE,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const schemaBreadcrumb = (items: Array<{ name: string; url: string }>) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE}${it.url}`,
    })),
  });

export const schemaService = (name: string, description: string, price: string) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    provider: { "@type": "LocalBusiness", name: "Up Diag" },
    areaServed: { "@type": "AdministrativeArea", name: "Île-de-France" },
    description,
    offers: {
      "@type": "Offer",
      price: price.replace(/[^0-9]/g, "") || "130",
      priceCurrency: "EUR",
    },
  });

export const schemaFaqPage = (items: Array<{ q: string; a: string }>) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a.replace(/<\/?strong>/g, "").replace(/&gt;/g, ">"),
      },
    })),
  });

export const schemaArticle = (
  title: string,
  description: string,
  image: string,
  category: string,
  datePublished = "2025-01-15"
) =>
  JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    image,
    author: { "@type": "Organization", name: "Up Diag" },
    publisher: {
      "@type": "Organization",
      name: "Up Diag",
      logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
    },
    datePublished,
    articleSection: category,
  });

/**
 * JSX helper: renders a <script type="application/ld+json"> tag.
 * Usage: {renderSchema(schemaLocalBusiness())}
 */
export const renderSchema = (json: string) => ({
  __html: json,
});
